<template>
  <div>
    <div v-if="lotteryAds && lotteryAds.length && isLoaded" class="container">
      <img
        v-if="ad1"
        :src="ad1.img"
        class="single-img"
        :style="{
          height: ad1.height / 2 + 'px'
        }"
      />
      <div>
        <div v-if="adCenter && adCenter.length" class="ad-list">
          <img
            v-for="(item, index) in adCenter"
            :key="index"
            :src="item.img"
            :style="{
              height: item.height / 2 + 'px'
            }"
            class="img"
            @click="onAdClick(item)"
          />
        </div>
      </div>
      <img
        v-if="ad6"
        :src="ad6.img"
        class="single-img"
        :style="{
          height: ad6.height / 2 + 'px'
        }"
        @click="onAdClick(ad6)"
      />
    </div>
    <img
      v-else-if="(!lotteryAds || !lotteryAds.length) && isLoaded"
      src="../../../images/money_tree/full_footer.jpg"
      class="full-footer"
    />
  </div>
</template>

<script>
import { API } from '@/api'

const AD_POSITION = {
  AD_POSITION1: 'money_tree_1',
  AD_POSITION6: 'money_tree_6',
  AD_POSITION_CENTER: [
    'money_tree_2',
    'money_tree_3',
    'money_tree_4',
    'money_tree_5'
  ]
}

export default {
  data() {
    return {
      lotteryAds: [],
      isLoaded: false,
      screeheight: document.documentElement.clientHeight
    }
  },
  computed: {
    ad1() {
      if (!this.lotteryAds || !this.lotteryAds.length) {
        return
      }
      const ad = this.lotteryAds.find(
        item => item.ad_position === AD_POSITION.AD_POSITION1
      )
      return ad
    },
    ad6() {
      if (!this.lotteryAds || !this.lotteryAds.length) {
        return
      }
      const ad = this.lotteryAds.find(
        item => item.ad_position === AD_POSITION.AD_POSITION6
      )
      return ad
    },
    adCenter() {
      if (!this.lotteryAds || !this.lotteryAds.length) {
        return
      }
      const ads = this.lotteryAds.filter(item => {
        if (AD_POSITION.AD_POSITION_CENTER.includes(item.ad_position)) {
          return true
        }
        return false
      })
      return ads
    }
  },
  mounted() {
    this.getLotteryAds()
  },
  methods: {
    /**
     * 获取广告位
     */
    async getLotteryAds() {
      try {
        const res = await API.moneyTree.getLotteryAds({})
        this.lotteryAds = res.lottery_ad_list || []
        this.isLoaded = true
        // this.lotteryAds.forEach(item => {
        // const itemWidth = AD_POSITION.AD_POSITION_CENTER.includes(
        //   item.ad_position
        // )
        //   ? 170
        //   : 375
        // item._height = this.calcuteHeight(item, itemWidth)
        // })
      } catch (error) {
        this.isLoaded = true
      }
    },

    /**
     * 点击广告
     */
    onAdClick(item) {
      // eslint-disable-next-line camelcase
      const { ad_position, action } = item
      // eslint-disable-next-line camelcase
      if (ad_position) {
        this.$track(this.$trackMap.moneyTree[ad_position], {
          ad_position
        })
      }
      if (!action || !action.payload) {
        // nativeRedirect(action.payload)
        return
      }

      const { payload } = action

      this.$autoRedirect(
        payload + '?spm=n.3961.' + this.$trackMap.moneyTree[ad_position]
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.container {
  display: flex;

  flex-direction: column;
  .more-activity {
    width: 100%;
    height: 2.47rem;
  }
  .single-img {
    width: 100%;

    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .ad-list {
    @include flex(row, space-between, normal, wrap);

    .img {
      width: calc(100% / 2);
      overflow: hidden;

      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
}

.full-footer {
  width: 100%;
  height: 170px;

  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.logo-wrap {
  display: flex;

  width: 100%;

  background: #fcf3e1;

  justify-content: center;

  align-items: center;
  .logo {
    width: 1.2rem;
    height: 0.5rem;
    margin: 0.3rem auto;

    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}
</style>
